import type { ParseKeys } from "i18next";

export const dashboardPath = "/dashboard";
export const settingsPath = "/settings/organization";
export const inventoryPath = "/inventory";
export const collectionsPath = "/collections";
export const activityPath = "/activity";

export const loginPath = "/auth/login";
export const loginShopifyPath = "/auth/shopify/login";
export const signupPath = "/auth/signup";
export const verifyPath = "/auth/verify";
export const onboardPath = "/onboard";

// labels are translation keys
export const settingsLinks = new Map<string, { label: ParseKeys; url: string }>([
  [
    "organization",
    {
      label: "settings.nav.organization",
      url: "/settings/organization",
    },
  ],
  [
    "billing",
    {
      label: "settings.nav.billing",
      url: "/settings/billing",
    },
  ],
  [
    "sku-generator",
    {
      label: "settings.nav.skuGenerator",
      url: "/settings/sku-generator",
    },
  ],
]);

export const integrationsNav = new Map<
  string,
  { label: ParseKeys; url: string }
>([
  [
    "account",
    {
      label: "integrations.nav.account",
      url: "/account",
    },
  ],
  [
    "import",
    {
      label: "integrations.nav.import",
      url: "/import",
    },
  ],
  [
    "messaging",
    {
      label: "integrations.nav.messaging",
      url: "/messaging",
    },
  ],
  [
    "reviews",
    {
      label: "integrations.nav.reviews",
      url: "/reviews",
    },
  ],
]);

export const shopifyAppStoreUrl = "apps.shopify.com/ebay-sync";

export const shopifyAppUrl = "";

export const ebayCallback = "/auth/ebay/callback";
export const ebayAlertsWebhook = "/api/ebay/ebay-webhook";

export const tawkPropertyID = "67d37569c27bee190e37c888";
export const tawkWidgetID = "1im9059m2";

export const VITE_API_URL = "https://" + import.meta.env.VITE_API_URL;
export const VITE_BASE_URL = "https://" + import.meta.env.VITE_BASE_URL;

export const users_route = "/v1/users";
export const users_me_route = "/v1/users";
export const send_confirmation_route = "/v1/users/send-confirmation";
export const users_shopify_route = "/v1/users/shopify";
export const users_subscription_route = "/v1/users/subscription";
export const users_subscription_one_time_route =
  "/v1/users/subscription/one-time";
export const users_sku_settings_route = "/v1/users/sku-settings";
export const users_sku_settings_generate_route =
  "/v1/users/sku-settings/generate";

export const organizations_route = "/v1/organizations";
export const organization_onboard_route = "/v1/organizations/onboard";
export const organization_link_code_route = "/v1/organizations/link-code";
export const organization_link_route = "/v1/organizations/link";

export const gated_route = "/v1/billing/gated";
export const subscription_plans_route = "/v1/billing/plans";
export const subscription_capped_mail_route = "/v1/billing/capped-mail";
export const shopify_subscription_reconnect_route =
  "/v1/billing/shopify/reconnect";

export const stripe_checkout_route = "/v1/billing/stripe/checkout";
export const stripe_sync_route = "/v1/billing/stripe/sync";
export const stripe_portal_route = "/v1/billing/stripe/portal";
export const platforms_route = "/v1/platforms";

export const shopify_sync_route = "/v1/billing/shopify/sync";

// shopify
export const platforms_shopify = "/v1/platforms/shopify";
export const platforms_shopify_reauth = "/v1/platforms/shopify/reauth";
export const platforms_shopify_scope = "/v1/platforms/shopify/scope-update";
export const platforms_shopify_shop = "/v1/platforms/shopify/shop";
export const platforms_shopify_alias = "/v1/platforms/shopify/alias";
export const platforms_shopify_fetch = "/v1/platforms/shopify/fetch";
export const platforms_shopify_metafield_definitions =
  "/v1/platforms/shopify/metafield-definitions";
// Shopify auth is now handled by the Go backend at these endpoints:
export const shopify_auth_route = "/auth/shopify";
export const shopify_callback_route = "/auth/shopify/callback";
export const shopify_connect_route = "/auth/shopify/connect";

export const shopify_login_auth_route = "/auth/shopify/login";

// ebay
export const platforms_ebay = "/v1/platforms/ebay";
export const platforms_ebay_fetch = "/v1/platforms/ebay/fetch";
export const platforms_ebay_fetch_estimate =
  "/v1/platforms/ebay/fetch/estimate";
export const platforms_ebay_alias = "/v1/platforms/ebay/alias";
export const platforms_ebay_policies = "/v1/platforms/ebay/policies";
export const platforms_ebay_categories = "/v1/platforms/ebay/categories";
export const platforms_ebay_oauth_url = "/v1/platforms/ebay/oauth/get-url";
export const platforms_ebay_oauth = "/v1/platforms/ebay/oauth";
export const platforms_ebay_oauth_shopify_redirect =
  "/v1/platforms/ebay/oauth/shopify-redirect";
export const platforms_ebay_messaging = "/v1/platforms/ebay/messaging";
export const platforms_ebay_order_sync = "/v1/platforms/ebay/orders/sync";
export const platforms_ebay_reviews = "/v1/platforms/ebay/reviews";
export const platforms_ebay_messaging_orders =
  "/v1/platforms/ebay/messaging/orders";
export const platforms_ebay_migrate = "/v1/platforms/ebay/migrate";
export const platforms_ebay_migrate_product =
  "/v1/platforms/ebay/migrate/product";

// tiktok
export const platforms_tiktok = "/v1/platforms/tiktok";
export const platforms_tiktok_alias = "/v1/platforms/tiktok/alias";
export const platforms_tiktok_fetch = "/v1/platforms/tiktok/fetch";
export const platforms_tiktok_order_sync = "/v1/platforms/tiktok/orders/sync";
export const platforms_tiktok_oauth_url = "/v1/platforms/tiktok/oauth/get-url";
export const platforms_tiktok_oauth_shopify_redirect =
  "/v1/platforms/tiktok/oauth/shopify-redirect";

// activity logs
export const activity_logs = "/v1/activity_logs";

// notifications
export const notifications_route = "/v1/notifications";

// products
export const products_route = "/v1/products";
export const platform_products_route = "/v1/platforms/products";
export const products_route_shopify = "/v1/platforms/products/shopify";
export const products_sync_route = "/v1/products/sync";

export const product_variant_cost_route = "/v1/variants/cost";

// collections
export const collections_route = "/v1/collections";
export const collections_import_route = "/v1/collections/import";

// inventory
export const inventory_events_route = "/v1/inventory";

// import
export const import_ebay_route = "/v1/import/ebay";
export const import_shopify_route = "/v1/import/shopify";

// sync
export const sync_config_route = "/v1/sync/config";
export const sync_toggle_route = "/v1/sync/toggle";

// analytics
export const analytics_overview_route = "/v1/analytics/overview";
